"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.Semaphore = void 0;
var promisify_1 = require("./promisify");
/**
 * A Semaphore which queues up tasks to be executed once prior tasks are complete.
 * Number of concurrent inflight tasks is configurable at initialization.
 */
var Semaphore = /** @class */ (function () {
    function Semaphore(config) {
        this.inflight = [];
        this.inflightTokens = 0;
        this.queue = [];
        this.listenerMap = new Map();
        this.addListener = this.on;
        this.removeListener = this.off;
        this.config = Object.assign({
            tokens: 1
        }, config);
        if (!this.config.tokens || this.config.tokens <= 0) {
            throw new Error('Tokens must be > 0');
        }
    }
    /**
     * Gets a snapshot of the current state of the semaphore.
     * @returns the current number of inflight requests, and the current queue size.
     */
    Semaphore.prototype.stats = function () {
        return {
            inflight: count(this.inflight, function (task) { return task.meta && task.meta.virtual ? 0 : 1; }),
            queueSize: this.queue.length,
            availableTokens: this.config.tokens - this.inflightTokens
        };
    };
    /**
     * Checks if the semaphore is currently empty.  You can poll this or wait for
     * the 'empty' event to be raised.
     */
    Semaphore.prototype.isEmpty = function () {
        return this.inflight.length == 0 && this.queue.length == 0;
    };
    /**
     * Wraps the given function inside a synchronization wrapper, which locks the
     * semaphore around every invocation of the function.
     * @param fn
     */
    Semaphore.prototype.synchronize = function (fn) {
        var semaphore = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var self = this;
            return semaphore.lock(function () {
                return fn.apply(self, args);
            });
        };
    };
    Semaphore.prototype.lock = function (action, rw) {
        var _this = this;
        if (rw === void 0) { rw = 'read'; }
        rw = rw && rw == 'write' ? 'write' : 'read';
        var task = {
            tokens: rw == 'write' ? this.config.tokens : 1,
            meta: { from: '_lock' },
            state: 'uninitialized'
        };
        var promise = new Promise(function (resolve, reject) {
            Object.assign(task, {
                state: 'initialized',
                action: function () { return (0, promisify_1.promisify)(function (cb) {
                    var lock = rw == 'write' ?
                        new Semaphore.WriteLockImpl(task, _this) :
                        new Semaphore.ReadLockImpl(task, _this);
                    return action(lock, cb);
                }); },
                resolve: function (result) {
                    _this._release(task);
                    resolve(result);
                },
                reject: function (err) {
                    _this._release(task);
                    reject(err);
                }
            });
            _this._onInitialized(task);
        });
        this._enqueue(task);
        return promise;
    };
    Semaphore.prototype._enqueue = function (task, priority) {
        var _this = this;
        if (task.state != 'initialized' && task.state != 'uninitialized') {
            throw new Error("Cannot enqueue a previously enqueued task! ".concat(task));
        }
        if (task.tokens <= 0) {
            throw new Error("Cannot enqueue a task with no tokens! ".concat(task));
        }
        if (task.state == 'initialized' &&
            this.queue.length == 0 &&
            (this.inflightTokens + task.tokens) <= this.config.tokens) {
            this.inflightTokens += task.tokens;
            this.inflight.push(task);
            // yield the execution queue before running the next request
            setTimeout(function () { return _this._runTask(task); }, 0);
        }
        else {
            if (priority) {
                this.queue.unshift(task);
            }
            else {
                this.queue.push(task);
            }
        }
    };
    Semaphore.prototype._onInitialized = function (task) {
        if (this.inflight.length == 0 && this.queue.length > 0) {
            // we need to pump the queue now that the task has been initialized
            this._releaseTokens(0);
        }
    };
    Semaphore.prototype._release = function (task) {
        var taskIndex = this.inflight.indexOf(task);
        if (taskIndex == -1 || task.state != 'running') {
            throw new Error("Cannot release a task that isn't running: ".concat(task));
        }
        this._releaseTokens(task.tokens);
        task.state = 'released';
        this.inflight.splice(taskIndex, 1);
        if (this.isEmpty()) {
            this._emit('empty');
        }
    };
    Semaphore.prototype._releaseTokens = function (tokens) {
        var _this = this;
        this.inflightTokens -= tokens;
        var nextTask = this.queue[0];
        if (nextTask) {
            if (nextTask.state == 'uninitialized') {
                // put it back on the queue till it gets initialized
                this._enqueue(nextTask);
            }
            else if (this.inflight.length == 0 || (this.inflightTokens + nextTask.tokens) <= this.config.tokens) {
                this.queue.shift();
                this.inflightTokens += nextTask.tokens;
                this.inflight.push(nextTask);
                // yield the execution queue before running the next request
                setTimeout(function () { return _this._runTask(nextTask); }, 0);
            }
        }
    };
    Semaphore.prototype._acquireTokens = function (tokens, priority) {
        var _this = this;
        var task = {
            state: 'uninitialized',
            meta: { from: '_acquireTokens', virtual: true },
            tokens: tokens
        };
        this._enqueue(task, priority);
        return new Promise(function (resolve, reject) {
            Object.assign(task, {
                state: 'initialized',
                action: function () {
                    return Promise.resolve(tokens);
                },
                resolve: function () {
                    // the tokens are transferred to the promise consumer
                    task.tokens = 0;
                    _this._release(task);
                    resolve(tokens);
                },
                reject: function (err) {
                    _this._release(task);
                    reject(err);
                }
            });
            _this._onInitialized(task);
        });
    };
    Semaphore.prototype._runTask = function (task) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (task.state == 'uninitialized') {
                            throw new Error("Cannot run an uninitialized task: ".concat(task));
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        task.state = 'running';
                        _b = (_a = task).resolve;
                        return [4 /*yield*/, task.action(task)];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        if (task.reject && task.state == 'running') {
                            task.reject(e_1);
                        }
                        else {
                            throw e_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Semaphore.prototype.on = function (event, listener) {
        var set = this.listenerMap.get(event);
        if (!set) {
            set = new Set();
            this.listenerMap.set(event, set);
        }
        set.add(listener);
        return this;
    };
    Semaphore.prototype.once = function (event, listener) {
        var _this = this;
        return this.on(event, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            try {
                listener.apply(void 0, args);
            }
            finally {
                _this.off(event, listener);
            }
        });
    };
    Semaphore.prototype.off = function (event, listener) {
        var set = this.listenerMap.get(event);
        if (set) {
            set["delete"](listener);
        }
        return this;
    };
    Semaphore.prototype._emit = function (event) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var set = this.listenerMap.get(event);
        if (set) {
            set.forEach(function (listener) {
                try {
                    listener.apply(_this, args);
                }
                catch (e) {
                    // ignore errors in listeners
                }
            });
        }
    };
    // tslint:disable:member-ordering
    // tslint:disable:max-classes-per-file
    // tslint:disable:variable-name
    Semaphore.ReadLockImpl = /** @class */ (function () {
        function class_1(task, semaphore) {
            this.task = task;
            this.semaphore = semaphore;
            this.type = 'read';
        }
        class_1.prototype.upgrade = function () {
            return __awaiter(this, void 0, void 0, function () {
                var taskIndex, maxTokens, p, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.consumed) {
                                throw new Error('Cannot upgrade again - please use the lock returned by previous upgrade() call');
                            }
                            taskIndex = this.semaphore.inflight.indexOf(this.task);
                            if (this.task.state != 'running' || taskIndex == -1) {
                                throw new Error("Cannot upgrade a non-running task!  Did you forget to await something?" +
                                    "  Task state was ".concat(this.task.state));
                            }
                            this.consumed = true;
                            maxTokens = this.semaphore.config.tokens;
                            p = this.semaphore._acquireTokens(maxTokens, true);
                            // acquiring max tokens doesn't happen till we release our task's tokens
                            this.semaphore._releaseTokens(this.task.tokens);
                            this.task.tokens = 0;
                            _a = this.task;
                            return [4 /*yield*/, p];
                        case 1:
                            _a.tokens = _b.sent();
                            return [2 /*return*/, new Semaphore.WriteLockImpl(this.task, this.semaphore)];
                    }
                });
            });
        };
        return class_1;
    }());
    Semaphore.WriteLockImpl = /** @class */ (function () {
        function class_2(task, semaphore) {
            this.task = task;
            this.semaphore = semaphore;
            this.type = 'write';
        }
        class_2.prototype.downgrade = function () {
            return __awaiter(this, void 0, void 0, function () {
                var tokensToRelease;
                return __generator(this, function (_a) {
                    if (this.consumed) {
                        throw new Error('Cannot downgrade again - please use the lock returned by previous downgrade() call');
                    }
                    tokensToRelease = this.task.tokens - 1;
                    if (tokensToRelease <= 0) {
                        throw new Error("Cannot downgrade a lock that has fewer than two tokens (had ".concat(this.task.tokens, ")"));
                    }
                    this.consumed = true;
                    this.semaphore._releaseTokens(tokensToRelease);
                    this.task.tokens -= tokensToRelease;
                    return [2 /*return*/, new Semaphore.ReadLockImpl(this.task, this.semaphore)];
                });
            });
        };
        return class_2;
    }());
    return Semaphore;
}());
exports.Semaphore = Semaphore;
function count(arr, fn) {
    var c = 0;
    for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
        var item = arr_1[_i];
        c += fn(item);
    }
    return c;
}
//# sourceMappingURL=semaphore.js.map